import { useEffect, useMemo, useState } from 'react';
import { Box, Button, CircularProgress, Container, Grid, Stack, Typography } from '@mui/material';
import { useParams, Link as RouterLink } from 'react-router-dom';
import api from '../../services/api';

export default function PublicProductoDetalle() {
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [producto, setProducto] = useState(null);
  const [selectedImage, setSelectedImage] = useState('');

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const { data } = await api.get(`/api/web/productos/${slug}`);
        if (mounted) {
          setProducto(data);
          setSelectedImage(data?.imagen_principal || data?.galeria?.[0]?.imagen_url || '');
        }
      } catch (error) {
        console.error('Error cargando producto', error);
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [slug]);

  const galeria = useMemo(() => {
    if (!producto) return [];
    const extra = (producto.galeria || []).map((x) => x.imagen_url).filter(Boolean);
    const all = [producto.imagen_principal, ...extra].filter(Boolean);
    return [...new Set(all)];
  }, [producto]);

  if (loading) {
    return (
      <Box sx={{ py: 12, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!producto) {
    return (
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Typography variant="h5">Product not found</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Button component={RouterLink} to="/catalogo" sx={{ mb: 3 }}>
        ← Back to catalog
      </Button>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src={selectedImage || '/logo.png'}
            alt={producto.nombre}
            sx={{
              width: '100%',
              height: 520,
              objectFit: 'cover',
              borderRadius: 4,
              boxShadow: 2
            }}
          />

          <Stack direction="row" spacing={1} sx={{ mt: 2, flexWrap: 'wrap' }}>
            {galeria.map((img, idx) => (
              <Box
                key={idx}
                component="img"
                src={img}
                alt={`img-${idx}`}
                onClick={() => setSelectedImage(img)}
                sx={{
                  width: 88,
                  height: 88,
                  objectFit: 'cover',
                  borderRadius: 2,
                  cursor: 'pointer',
                  border: selectedImage === img ? '2px solid #111' : '1px solid #ddd'
                }}
              />
            ))}
          </Stack>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="overline">{producto.categoria_nombre}</Typography>
          <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
            {producto.nombre}
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 700, mb: 3 }}>
            {producto.precio != null
              ? `$${Number(producto.precio).toFixed(2)}`
              : 'Request pricing'}
          </Typography>

          <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
            {producto.descripcion || 'Flower variety available.'}
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
}
